<template>
<!--  <b-spinner v-if="barcodeOn" small type="grow" variant="success" class="float-right"></b-spinner>-->
</template>

<script>

  import miniToastr from "mini-toastr";

  const toastTypes = {
    success: "success",
    error: "error",
    info: "info",
    warn: "warn"
  };

  miniToastr.init({types: toastTypes});

  export default {
    name: "BarcodeScanner.vue",
    data() {
      return {
        notificacion_mensaje: "",
        checkWeapor: false,
        inputCodePallet: "",
      }
    },
    props: [
      "waybill_id",
      "addPalletswaybill",
      'client_customer'
    ],
    created() {
     
    },
    destroyed () {
      // Remove listener when component is destroyed
      // this.$barcodeScanner.destroy()
    },
    computed: {
      barcodeOn() {
        return this.$barcodeScanner.hasListener();
      }
    },
    methods: {

      onBarcodeScanned (barcode) {
        
        var vm = this;
        const Data = {
          waybillId: this.waybill_id,
          numero_pallet: barcode,
          client_customer: this.client_customer.id
        };
        this.$axios
          .put("/api/v1/allstock/dispatch_pallet/", Data)
          .then(res => {
            const data = res.data.datos;
            if (res.data.status == 0) {
              miniToastr.error(
                "Pallets " + vm.inputCodePallet + " no exite",
                ""
              );
            }
            if (res.data.status == 3) {
              miniToastr.warn("Pallet no pertenece a  " + vm.client_customer.text);
            }
            if (res.data.status == 2) {
              miniToastr.warn("Pallet " + vm.inputCodePallet + " no ingresado. Ya fue despachado.");
            }
            if (res.data.status == 1) {
              this.$emit("addPalletswaybill");
              miniToastr.success("Pallets ingresado con exito", "");
            }
            this.inputCodePallet = "";
            this.$refs.search.focus();
          })
          .catch(error => console.log(error));

        console.log(barcode)
        this.$nextTick( () => {
            // this.$refs['barcodemodal'].show()
          }
        )

      },

      blurInput(b) {
        this.checkWeapor = false;
      },
      focusInput(a) {
        this.checkWeapor = true;
      },
      addEventChange({type, target}) {
        if (this.checkWeapor == false) {
          this.checkWeapor = true;
        }
        var padre = this;
        const Data = {
          waybillId: this.waybill_id,
          numero_pallet: this.inputCodePallet,
          client_customer: this.client_customer.id
        };
        this.$axios
          .put("/api/v1/allstock/dispatch_pallet/", Data)
          .then(res => {
            const data = res.data.datos;
            if (res.data.status == 0) {
              miniToastr.error(
                "Pallets " + padre.inputCodePallet + " no exite",
                ""
              );
            }
            if (res.data.status == 3) {
              miniToastr.warn("Pallet no pertenece a  " + padre.client_customer.text);
            }
            if (res.data.status == 2) {
              miniToastr.warn("Pallet " + padre.inputCodePallet + " no ingresado. Ya fue despachado.");
            }
            if (res.data.status == 1) {
              this.$emit("addPalletswaybill");
              miniToastr.success("Pallets ingresado con exito", "");
            }
            this.inputCodePallet = "";
            this.$refs.search.focus();
          })
          .catch(error => console.log(error));
      },
    },
    watch: {
      checkWeapor: function (val) {
        if (val === true) {
          this.$refs.search.focus();
        }

        if (val === false) {
          this.$refs.search.blur();
          this.inputCodePallet = "";
        }
      }
    },
  }
</script>

<style scoped>

</style>
